import { render, staticRenderFns } from "./LandlordPage.vue?vue&type=template&id=47b87da5&scoped=true&"
import script from "./LandlordPage.vue?vue&type=script&lang=js&"
export * from "./LandlordPage.vue?vue&type=script&lang=js&"
import style0 from "./LandlordPage.vue?vue&type=style&index=0&id=47b87da5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b87da5",
  null
  
)

export default component.exports